import Cookies from 'js-cookie';
import { getItem, setItem } from '../utility/cookieStorage';

const AUTH_TOKEN_KEYS = ['access_token', 'refresh_token', 'access_expires_at', 'refresh_expires_at'];

/**
 * Login / refresh yanıtlarında envelope: { success, data: { token, ... } } veya düz alanlar.
 */
export function unwrapAuthResponse(data) {
  if (!data || typeof data !== 'object') {
    return {};
  }
  const nested = data.data;
  if (nested && typeof nested === 'object' && ('token' in nested || 'success' in nested || 'refresh_token' in nested)) {
    return { ...data, ...nested };
  }
  return data;
}

export function isAuthRefreshResponseSuccess(payload) {
  const p = unwrapAuthResponse(payload);
  if (p.success === false) {
    return false;
  }
  return typeof p.token === 'string' && p.token.length > 0;
}

export function getRefreshToken() {
  return getItem('refresh_token');
}

/** Eski token kalıntılarını temizler; login öncesi atomik çift yazımı için. */
export function clearAuthTokens() {
  AUTH_TOKEN_KEYS.forEach((k) => Cookies.remove(k));
}

export function getAccessExpiresAtMs() {
  const until = getItem('access_expires_at');
  if (!until) {
    return null;
  }
  const ts = parseInt(String(until), 10);
  if (Number.isNaN(ts)) {
    return null;
  }
  return ts;
}

/** access_expires_at dolmuş mu (sunucu expires_in ile yazılır). */
export function isAccessTokenExpired() {
  const until = getAccessExpiresAtMs();
  if (!until) {
    return false;
  }
  return Date.now() >= until;
}

/** Access süresinin dolmasına kalan ms; bilinmiyorsa null. */
export function getMsUntilAccessExpiry() {
  const until = getAccessExpiresAtMs();
  if (!until) {
    return null;
  }
  return Math.max(0, until - Date.now());
}

/**
 * Login sonrası access + refresh + süre bilgileri.
 * Önce eski token'lar silinir; kısmi güncelleme (eski refresh + yeni access) engellenir.
 */
export function persistTokensFromLogin(responseData) {
  clearAuthTokens();
  const p = unwrapAuthResponse(responseData);
  if (p.token) {
    setItem('access_token', p.token);
  }
  if (p.refresh_token) {
    setItem('refresh_token', p.refresh_token);
  }
  if (typeof p.expires_in === 'number' && p.expires_in > 0) {
    setItem('access_expires_at', String(Date.now() + p.expires_in * 1000));
  }
  if (typeof p.refresh_expires_in === 'number' && p.refresh_expires_in > 0) {
    setItem('refresh_expires_at', String(Date.now() + p.refresh_expires_in * 1000));
  }
}

/**
 * POST /auth/refresh yanıtı — yeni refresh_token gelmez; mevcut cookie korunur.
 */
export function applyTokensFromRefreshResponse(responseData) {
  const p = unwrapAuthResponse(responseData);
  if (p.token) {
    setItem('access_token', p.token);
  }
  if (typeof p.expires_in === 'number' && p.expires_in > 0) {
    setItem('access_expires_at', String(Date.now() + p.expires_in * 1000));
  }
  if (typeof p.refresh_expires_in === 'number' && p.refresh_expires_in > 0) {
    setItem('refresh_expires_at', String(Date.now() + p.refresh_expires_in * 1000));
  }
}

/** Uzun ömürlü refresh süresi doldu mu (sunucu refresh_expires_in ile güncellenir). */
export function isRefreshSessionExpired() {
  const until = getItem('refresh_expires_at');
  if (!until) {
    return false;
  }
  const ts = parseInt(String(until), 10);
  if (Number.isNaN(ts)) {
    return false;
  }
  return Date.now() >= ts;
}

const AUTH_KEYS_TO_CLEAR = [
  'logedIn',
  'access_token',
  'refresh_token',
  'user',
  'organization',
  'currentOrganizationId',
  'environemnt',
  'environment',
  'access_expires_at',
  'refresh_expires_at',
  'remember_me',
];

export function clearAuthSessionCookies() {
  AUTH_KEYS_TO_CLEAR.forEach((k) => Cookies.remove(k));
}
